import { Text } from '@ui/atoms';
const AssesmentTitleCard = ({ title, description }) => {
    return (
        <div className="bg-basicWhite shadow-credit-evaluation-card p-4 md:p-6 rounded-xl max-w-max flex gap-4 relative -left-7 md:-left-9">
            <div class="w-5 h-5 relative md:mt-1">
                <div class="w-5 h-5 left-0 top-0 absolute bg-secondary-100 rounded-full"></div>
                <div class="w-3 h-3 left-[4px] top-[4px] absolute bg-secondary-500 rounded-full"></div>
            </div>

            <div className="flex flex-col gap-2">
                <Text
                    content={title}
                    className="p5-medium md:p4-medium text-gray-500"
                    htmlTag='h2'
                />
                <Text
                    content={description}
                    className="p3-semibold md:h4-semibold text-primary-500"
                    htmlTag='h3'
                />
            </div>
        </div>
    );
};

export default AssesmentTitleCard;
